export default __webpack_public_path__ + "img/logo.444778ad.svg";